import { render, staticRenderFns } from "./ListingsDashboard.vue?vue&type=template&id=067c12ea"
import script from "./ListingsDashboard.vue?vue&type=script&lang=js"
export * from "./ListingsDashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports